/**
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';
import AppService from '@/services/app';
import Store from '@/store/index';

export default {

  resetStore() {
    // reset store to empty
    Store.dispatch('routes/setAdjustmentHeaders', {
      adjustmentHeaders: [],
    });
  },

  async listAll(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['routes/adjustmentHeaders'].length < 1) {
      try {
        const response = await Api(true).get('/route/adjustment/list_headers');

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetStore();
            return response.data.message;
          } else {
            Store.dispatch('routes/setAdjustmentHeaders', {
              adjustmentHeaders: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetStore();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('routeAdjustments.ts - listAll - 46 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  listAdjustmentsByHeader(config: {params: { headerId: number }}) {
    return Api(true).get('/route/adjustment/list_by_header', config);
  },

  create(params: {
    customerId: number,
    routeIds: string,
    effectiveDate: string,
    amount: number,
    adjustUp: boolean,
    description: string,
  }) {
    return Api(true).post('/route/adjustment/create', params);
  },

  approve(params: {
    id: number,
  }) {
    return Api(true).post('/route/adjustment/approve', params);
  },

  delete(params: {
    id: number,
  }) {
    return Api(true).post('/route/adjustment/delete', params);
  },

  search(config: {params: { 
    customerId: number,
    startDate: string,
    endDate: string,
  }}) {
    return Api(true).get('/route/adjustment/search', config);
  },

}